<template>
  <div
    :id="this.id"
    @contextmenu.prevent="handler($event)"
    class="sitebuilder-element-container"
    element="SliderGalleryComponent"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :config-properties="JSON.stringify(internal_config)"
    :style="style()"
    v-on:click="focusElement($event)"
  >
    <vue-draggable-resizable
      v-bind:w="parseInt(internal_config.width)"
      v-bind:h="parseInt(internal_config.height)"
      @resizing="onResize" ref="draggableResizable"
      :draggable="false"
    >
      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
      <sync-drag :target="this" />
      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-SliderGalleryComponent'>
        <img src="static/images/icons/add.svg"
          class="svg-icon normal-action"
          v-tooltip="{content:$t('ct-option-add-image'),  class: 'tooltip-custom'}"
          @click="openPopupImage"
        />
      </options-element-bar>

      <div
        ref="slider-gallery"
        class="slider-gallery"
        :config-properties="JSON.stringify(internal_config)"
        :style="{
          opacity: opacity,
          'border-radius': radius,
          border : border,
          'box-shadow': boxShadow,
          minHeight : minHeight
          }"
      >
        <div
          v-for="(image, index) in internal_config.images"
          :key="index"
          :class="`slider-image-${index}`"
          :style="{ backgroundImage: `url('${image}')` }"
        ></div>
      </div>
      <div class="slider-navigation" v-show="arrowOptions">
        <div class="mdi mdi-arrow-left-circle" @click="prevSlider" :style="styleArrow()"></div>
        <div class="mdi mdi-arrow-right-circle" @click="nextSlider" :style="styleArrow()"></div>
      </div>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>

  </div>
</template>

<script>
  import SliderData from "./Model";
  import Resources from "./Resources.vue";
  import OptionsElementBar from "../OptionsElementBar";

  export default {
    name: "SliderGalleryComponent",
    props: ["config", "id", "preview"],
    components: {
      OptionsElementBar,
      Resources
    },
    computed: {
      arrowOptions() {
        return this.internal_config.arrowOptions;
      },
      timerSlider() {
        return this.internal_config.timerSlider;
      },
      minHeight() {
        return this.internal_config.minHeight;
      },
      opacity() {
        return this.internal_config.opacity;
      },
      border() {
        return this.internal_config.border;
      },
      boxShadow() {
        return this.internal_config.boxShadow;
      },
      radius() {
        return this.internal_config.borderRadius;
      }
    },
    data() {
      return SliderData.data();
    },
    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      },
    },
    methods: {
      openPopupImage(){

        this.$root.$emit('openSliderGalleryModal', this.internal_config, 'sliderAddImage', this.saveAll);
      },
      saveAll(config) {
        this.internal_config = Object.assign({}, this.internal_config, config);
        $(this.$el).css({zIndex: this.internal_config.zIndex});
        // this.$refs.modal.close();
      },
      destroyAutoPlay() {
        clearTimeout(this.internal_config.slider);
      },
      buildSlider() {
        this.internal_config.currentIndex = 0;
        document
          .getElementById(this.id)
          .getElementsByClassName(
            `slider-image-${this.internal_config.currentIndex}`
          )[0].style.left = 0;
        this.autoPlaySlider();
      },
      prevSlider() {

        if (!this.$props.preview) return false;

        const {currentIndex, images} = this.internal_config;
        const nextIndex = currentIndex ? currentIndex - 1 : images.length - 1;

        const nextImage = document
          .getElementById(this.id)
          .getElementsByClassName(`slider-image-${nextIndex}`)[0];

        const prevImage = document
          .getElementById(this.id)
          .getElementsByClassName(`slider-image-${currentIndex}`)[0];

        nextImage.style.left = "-100%";
        prevImage.style.left = 0;

        nextImage.setAttribute(
          "class",
          `slider-image-${nextIndex} slider-in-left`
        );
        prevImage.setAttribute(
          "class",
          `slider-image-${currentIndex} slider-out-right`
        );

        this.internal_config.currentIndex = nextIndex;

        this.autoPlaySlider();
      },
      nextSlider() {

        if (!this.$props.preview) return false;

        const {currentIndex, images} = this.internal_config;
        const nextIndex =
          currentIndex === images.length - 1 ? 0 : currentIndex + 1;

        const nextImage = document
          .getElementById(this.id)
          .getElementsByClassName(`slider-image-${nextIndex}`)[0];

        const prevImage = document
          .getElementById(this.id)
          .getElementsByClassName(`slider-image-${currentIndex}`)[0];

        nextImage.style.left = "100%";
        prevImage.style.left = 0;

        nextImage.setAttribute(
          "class",
          `slider-image-${nextIndex} slider-in-right`
        );
        prevImage.setAttribute(
          "class",
          `slider-image-${currentIndex} slider-out-left`
        );

        this.internal_config.currentIndex = nextIndex;

        this.autoPlaySlider();
      },
      autoPlaySlider() {
        this.destroyAutoPlay();

        if (!this.$props.preview || !this.internal_config.autoPlaySlider) return false;

        this.internal_config.slider = setTimeout(() => {
          this.nextSlider();
        }, this.internal_config.timerSlider);
      },
      saveFile(image) {
        document
          .getElementsByClassName("panel-components-right")[0]
          .removeAttribute("style");

        this.internal_config.images.push(image);

        let values = {
          action: "close",
          type: "Files",
          save: this.saveFile,
          close: this.closeFile
        };
        this.$root.$emit("fileMananger", values);
      },
      closeFile() {
        document
          .getElementsByClassName("panel-components-right")[0]
          .removeAttribute("style");

        let values = {
          action: "close",
          type: "Files",
          save: this.saveFile,
          close: this.closeFile
        };
        this.$root.$emit("fileMananger", values);
      },
      animation() {
        return true;
      },
      onResize(x, y, width, height) {
        this.internal_config.width = width + "px";
        this.internal_config.height = height + "px";

        this.$refs.resourcesData.setValuesData(this);
      },
      focusElement(e) {
        this.$root.$emit("focusElement", this);
        this.$root.$emit('handlerElement', this);


        e.stopPropagation();
        e.preventDefault();
      },
      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },
      style() {
        var style = `width: ${this.internal_config.width};
                     height:  ${this.internal_config.height};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     left:  ${this.internal_config.left};
                     top: ${this.internal_config.top}`;
        return style;
      },
      styleArrow() {
        return `font-size: ${this.internal_config.arrowSize};
                color: ${this.internal_config.arrowColor}`;
      },
      styleResize() {
        return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
      },
      handler(e) {
        this.$root.$emit("focusElement", this);
        this.$root.$emit("handlerElement", this, true);
        e.stopPropagation();
        e.preventDefault();
      },
      hover() {
        this.$emit("highlightHover", {
          name: this.name,
          posicao: this.$refs.image.getBoundingClientRect()
        });
      },

      rebuild(config) {
        let vm = this;
        this.internal_config = {};
        this.$nextTick(() => {
          vm.internal_config = config;
          this.$nextTick(() => {
            vm.buildSlider();
            this.$root.$emit('rSidebarEdition', vm);
          });
        });
      },
    },
    created() {
      this.internal_config = window.mergeRecursive(
        this.props,
        this.$props.config
      );
    },
    mounted() {
      if (this.$props.preview) {
        this.$root.$emit("applyAnimation", this, "sitebuilder-element-container");
      }

      this.$refs.resourcesData.setValuesData(this);
      this.buildSlider();

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });
      if (objIds.includes(this.id)) {
        this.id = Date.now() + parseInt(Math.random() * 10000);
      }

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });
    }
  };
</script>
<style lang="scss" scoped>

  .slider-modal-images {
    display: flex;
    flex-direction: column;

    :nth-child(4) {
      text-align: right;
    }
  }

  .slider-area-images {
    display: grid;
    grid-template-columns: repeat(4, auto);
    grid-row-gap: 10px;
    grid-column-gap: 10px;
    margin: 20px 0 20px 0;
  }

  .slider-box-image {
    position: relative;
    background-color: rgba(29, 64, 89, 0.8);
    border-radius: 10px;

    .slider-box-image {
      width: 100%;
      height: 150px;
      opacity: 1;
      display: block;
      transition: 0.5s ease;
      backface-visibility: hidden;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }

    &:hover .slider-box-image {
      opacity: 0.3;
    }

    .slider-box-option {
      transition: 0.5s ease;
      opacity: 0;
      position: absolute;
      width: 34px;
      height: 34px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      text-align: center;

      span {
        width: 100%;
        height: 100%;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
          background-color: gray;
        }
      }
    }

    &:hover .slider-box-option {
      opacity: 1;
    }
  }

  //CSS SLIDER
  .slider-gallery {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;

    div {
      position: absolute;
      height: 100%;
      width: 100%;
      left: 100%;
      top: 0;
      background-size: cover;
    }
  }

  .slider-navigation {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 0;

    div {
      color: #d1d1d1;
      font-size: 25px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .slider-in-right {
    left: -100%;
    -webkit-animation: slideIn 1s forwards;
    animation: slideIn 1s forwards;
  }

  .slider-in-left {
    left: 100%;
    -webkit-animation: slideIn 1s forwards;
    animation: slideIn 1s forwards;
  }

  .slider-out-right {
    -webkit-animation: slideOutRight 1s forwards;
    animation: slideOutRight 1s forwards;
  }

  .slider-out-left {
    -webkit-animation: slideOutLeft 1s forwards;
    animation: slideOutLeft 1s forwards;
  }

  @keyframes slideIn {
    100% {
      left: 0;
    }
  }

  @keyframes slideOutRight {
    100% {
      left: 100%;
    }
  }

  @keyframes slideOutLeft {
    100% {
      left: -100%;
    }
  }

  @-webkit-keyframes slideOutLeft {
    100% {
      left: -100%;
    }
  }

  @-webkit-keyframes slideIn {
    100% {
      left: 0;
    }
  }

  @-webkit-keyframes slideOutRight {
    100% {
      left: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/SliderGallery/SliderGallery.vue